export default function editPractice(practiceObj = {}, action) {
  if (action.type === 'editPractice') {
    return action.practiceObj;
  } else {
    return practiceObj;
  }
}
